<template>
  <div id="app">
    <header-bar :page-name="'live'" :icon-color="'#7b7a7a'" facebookShareURL="https://udn.com/newmedia/921/live/" lineShareURL="https://udn.com/newmedia/921/live/"></header-bar>
    <Covers></Covers>


    <router-view/>

    <!-- <router-view/> -->
  </div>
</template>

<script>
import HeaderBar from '../../general_components/HeaderBar.vue'
import ScrollDownArrow from '../../general_components/ScrollDownArrow.vue'
import SlideShowBox from '../../general_components/SlideShowBox.vue'
import GeneralWidget from '../../general_components/GeneralWidget.vue'
import Relate from '../../general_components/Relate.vue'
import Comment from '../../general_components/Comment.vue'
import Logo from '../../general_components/Logo.vue'
import Author from '../../general_components/Author.vue'
import Footer from '../../general_components/Footer.vue'

import Covers from '@/components/Covers.vue'

export default {
  name: 'app',
  components: {
    HeaderBar,
    ScrollDownArrow,
    SlideShowBox,
    GeneralWidget,
    Relate,
    Comment,
    Logo,
    Author,
    Footer,
    Covers
  }
}
</script>


<style lang="sass">
body, html
  margin: 0
</style>
